import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import i18n from '../../i18n';
import HandleErrors from '../../utils/HandleErrors';
import { setRemarks, getRemarks } from '../../actions/collection';
import CollectionFunnelEvents from '../../utils/collectionFunnelEvents';

const Remarks = (props) => {
    const { register, handleSubmit, errors, formState, setValue } = useForm();
    const navigate = useNavigate();
    const onSubmit = (data) => {
        if (!_.isEmpty(data)) {
            props.getSending(true);
            CollectionFunnelEvents.funnelProgress(6);
            props.setRemarks(data).then(() => navigate(location.pathname.replace(/[^/]*$/, 'step7')));
        }
    };

    useEffect(() => {
        if (!formState.dirty) {
            props.getRemarks().then((result) => setValue('remarks', result.payload.remarks));
        }
    }, []);

    useEffect(() => {
        props.hasError(formState.dirtyFields.size !== 1);
    }, [formState]);

    return (
        <form id="form-step-6" onSubmit={handleSubmit(onSubmit)}>
            <h2 className="title-remarks">{i18n.t('collection:anything_to')}</h2>
            <div className="container-form-group">
                <div className="text-home">
                    <p>{i18n.t('collection:do_you_have')}</p>
                </div>
                <div className="form-group">
                    <div className="form-label">
                        <label htmlFor="remarks">{i18n.t('collection:what_makes')}</label>
                    </div>
                    <textarea
                        id="remarks"
                        name="remarks"
                        ref={register}
                        rows="5"
                        cols="33"
                        placeholder={i18n.t('collection:remarks_placeholder')}
                        defaultValue={props.remarks ? props.remarks : ''}
                    />
                    {!_.isEmpty(errors.remarks) &&
                        HandleErrors.renderErrors(errors.remarks, errors.remarks.message)}
                </div>
            </div>
        </form>
    );
};

Remarks.propTypes = {
    getSending: PropTypes.func,
    hasError: PropTypes.func,
    remarks: PropTypes.string,
    setRemarks: PropTypes.func,
    getRemarks: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
    setRemarks: bindActionCreators(setRemarks, dispatch),
    getRemarks: bindActionCreators(getRemarks, dispatch)
});

const mapStateToProps = (state) => ({
    remarks: state.collection.remarks
});

export default connect(mapStateToProps, mapDispatchToProps)(Remarks);
